import { gql } from '@apollo/client'

export const AEM_HOMEPAGE = gql`
  query AemHomepage($path: String!) {
    aemHomepage(path: $path)
  }
`
